export enum Product {
  Buffer = 'buffer',
  Analyze = 'analyze',
  Publish = 'publish',
  Engage = 'engage',
  Marketing = 'marketing',
  Account = 'account',
}
